/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunicationTemplateSearchRequestModel } from '../../models/communication-template-search-request-model';
import { CommunicationTemplateSearchResultModel } from '../../models/communication-template-search-result-model';

export interface CommunicationTemplateSearchPost$Params {
      body?: CommunicationTemplateSearchRequestModel
}

export function communicationTemplateSearchPost(http: HttpClient, rootUrl: string, params?: CommunicationTemplateSearchPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<CommunicationTemplateSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, communicationTemplateSearchPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<CommunicationTemplateSearchResultModel>>;
    })
  );
}

communicationTemplateSearchPost.PATH = '/CommunicationTemplate/Search';
